import groupedRequestDetailsStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_USER_RESPONSE_MESSAGE', function setUserResponseMessageInStore(userResponseMessage: string) {
    if (groupedRequestDetailsStore) {
        groupedRequestDetailsStore.userResponseMessage = userResponseMessage;
    }
});